import {
  POST_FOLLOW_CALL_APPOINTMENT_REQUEST,
  POST_FOLLOW_CALL_APPOINTMENT_SUCCESS,
  POST_FOLLOW_CALL_APPOINTMENT_FAILURE,
} from '../../constants/ActionTypes'
import { HTTP_400_BAD_REQUEST_CODE } from "../../constants/HttpStatusCode";

const initialState = {
  isSaving: false,
  error: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case POST_FOLLOW_CALL_APPOINTMENT_REQUEST:
      return {
        error: {},
        isSaving: true,
      }
    case POST_FOLLOW_CALL_APPOINTMENT_SUCCESS:
      return {
        isSaving: false,
        error: {}
      };
    case POST_FOLLOW_CALL_APPOINTMENT_FAILURE:
      if (action.payload.error.status === HTTP_400_BAD_REQUEST_CODE) {
        let err = {};
        if (typeof action.payload.error.data.message === "string") {
          err["message"] = action.payload.error.data.message;
        } else {
          for (let key in action.payload.error.data.message) {
            if (Array.isArray(action.payload.error.data.message[key])) {
              err[key] = action.payload.error.data.message[key].join(",");
            } else if (
              typeof action.payload.error.data.message[key] === "string"
            ) {
              err[key] = action.payload.error.data.message;
            }
          }
        }

        return {
          isSaving: false,
          error: err,
        };
      } else {
        return {
          error: action.payload.error.data.message,
          isSaving: false,
        };
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/followCallAppointment.js